// Scope check usable outside of CoreEngine subclasses (functional components, helpers).
export const hasAnyScope = (requiredScopes = []) => {
  const userScopes = (sessionStorage.getItem("scopes") || "")
    .split(",")
    .map((scope) => scope.trim());
  return requiredScopes.some(
    (scope) => scope && userScopes.includes(scope.toLowerCase())
  );
};
